const Divider = () => <div className="my-2 w-full h-[1px] bg-gray-300" />;

export default Divider;
